module.exports = __webpack_public_path__ + "985d5ddf042a88959bd0ba8fa392dd8c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-princess.png
// module id = 2227
// module chunks = 0